import React, { useState } from 'react';
//Material
import { Box, IconButton } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
//Components
import { useSyles } from './SearchInvisible.styles';

const SearchInvisible = ({
  onHandleChange,
  placeholder,
  resetValueOnClick = false,
  isDisabled = false,
}) => {
  const classes = useSyles();

  const [value, setValue] = useState('');
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <Box className={classes.container}>
      <Box
        className={`${classes.buttonAction} ${
          value ? classes.buttonActionActive : ''
        }`}
      >
        <input
          type='text'
          name='name_value'
          value={value}
          className={`!border !border-gray-400 rounded-lg ${classes.invisibleInput}`}
          onChange={handleChange}
          placeholder={placeholder}
        />
        <IconButton
          type='submit'
          name='action_find'
          className='!ml-4'
          disabled={!value || isDisabled}
          onClick={() => {
            onHandleChange(value);
            if (resetValueOnClick) {
              setValue('');
            }
          }}
        >
          <ArrowForward />
        </IconButton>
      </Box>
    </Box>
  );
};

export default SearchInvisible;
